<template>
  <div class="va-video-file-input">
    <div class="d-flex align-center">
      <v-file-input
        class="flex-grow-1"
        @change="fileChanged"
        :value="file"
        :loading="loading"
        :label="label"
        accept="video/mp4,.mp4"></v-file-input>
      <v-btn
        v-if="downloadFileId || value"
        type="link"
        :ripple="false"
        plain
        class="ml-2 va-video-file-input__action"
        @click="downloadFile">
        <v-icon small class="mr-1">mdi-download</v-icon>
        {{ $t("generic.buttons.download") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { sendToServer, downloadMediaObject } from "@/utility/mediaObjectUploadHelper";
  import { formErrorMessage } from "@/utility/formErrorMessage";
  import definedAbility from "@/ability";

  export default {
    name: "VaVideoFileInput",
    props: {
      value: {
        type: String,
        default: "",
      },
      fileId: {
        type: String,
        default: "",
      },
      label: {
        type: String,
        default: "Video",
      },
    },
    data() {
      return {
        loading: false,
        file: null,
        uploadedFileId: "",
      };
    },
    computed: {
      downloadFileId() {
        return this.uploadedFileId || this.fileId;
      },
    },
    watch: {
      value: {
        immediate: true,
        handler(val) {
          if (!val) {
            this.file = null;
            return;
          }
          if (this.file) return;
          const name = val.split("/").pop().split("?")[0];
          this.file = new File([""], name);
        },
      },
    },
    methods: {
      async downloadFile() {
        if (this.downloadFileId) {
          try {
            await downloadMediaObject(this.downloadFileId, this.file?.name || "");
          } catch (e) {
            this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
          }
        } else if (this.value) {
          (window.top || window).open(this.value, "_blank");
        }
      },
      async fileChanged(file) {
        if (file && file.size === 0) {
          return;
        }
        if (file) {
          this.loading = true;
          try {
            const res = await sendToServer(file);
            this.file = file;
            this.uploadedFileId = res["@id"] || "";
            const contentUrl = res.contentUrl;
            const ability = definedAbility();
            const url =
              ability.can("upload", "media object to inulti server") && contentUrl && !contentUrl.startsWith("http")
                ? process.env.VUE_APP_API + contentUrl
                : contentUrl || "";
            this.$emit("update:fileId", this.uploadedFileId);
            this.$emit("input", url);
          } catch (e) {
            this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
          } finally {
            this.loading = false;
          }
        } else {
          this.uploadedFileId = "";
          this.$emit("update:fileId", "");
          this.$emit("input", "");
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";

  .va-video-file-input {
    ::v-deep .v-file-input__text {
      padding-left: 8px;
    }

    &__action {
      color: get-color("secondary-btn");

      i {
        transition: none;
      }

      &:hover {
        color: get-color("same-hover");
      }
    }
  }
</style>
